import React, { useState, useEffect, useRef } from "react";
import "../AddClients/tableStyle.css";
import { getDoData } from "../../Services/Services";
import { Col, Input, Button, Form } from "antd";
import LifterAssFrm from "./LifterAssFrm";
import LifterAssignUpdate from "./LifterAssignUpdate";
import Header from "../Header-Footer/Header";
import { useReactToPrint } from "react-to-print";
import * as XLSX from "xlsx"; // Import xlsx library
import { Link } from "react-router-dom";
import { FaFilePdf, FaFileExcel } from "react-icons/fa";
import Footer from "../Header-Footer/Footer";
import { EditOutlined } from "@ant-design/icons";

export default function LifterAssView() {
  const [assignDetails, setassignDetails] = useState([]);
  const [assignList, setassignList] = useState([]);
  const [selectedDo, setSelectedDo] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    GetAssignDo();
  }, []);

  const GetAssignDo = async () => {
    if (localStorage.getItem("user_type") === "Lifter") {
      const response = await getDoData({
        lifter_id: localStorage.getItem("user_id"),
        com_name: localStorage.getItem("com_name"),
      });
      if (response) {
        const sortedArray = [...response].sort((a, b) => b.id - a.id);
        setassignDetails(sortedArray);
        setassignList(sortedArray);
      }
    } else {
      const response = await getDoData({
        com_name: localStorage.getItem("com_name"),
        is_lifter: true,
      });
      if (response) {
        const sortedArray = [...response].sort((a, b) => b.id - a.id);
        setassignDetails(sortedArray);
        setassignList(sortedArray);
      }
    }
  };

  const handleEdit = (record) => {
    setSelectedDo(record);
    setIsModalOpen(true);
  };

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const handleExportToExcel = () => {
    const workbook = XLSX.utils.book_new();
    const wsData = assignDetails.map((e, index) => [
      index + 1,
      e.lifter_name,
      e.date,
      e.client_name,
      e.do_no,
      e.quantity,
      e.freight_rate,
      e.shortage_rate,
      e.lifting_rate,
      e.dis_qty,
      e.rem_qty,
    ]);

    const worksheet = XLSX.utils.aoa_to_sheet([
      [
        "Sr. No",
        "Lifter Name",
        "Lifting Date",
        "Party Name",
        "Do No.",
        "Lifting Quantity",
        "Freight Rate",
        "Shortage Rate",
        "Lifting Rate",
        "Dispatch Qty",
        "Balance Qty",
      ],
      ...wsData,
    ]);

    XLSX.utils.book_append_sheet(workbook, worksheet, "assignDetails");

    // Save the workbook as an Excel file
    XLSX.writeFile(workbook, "Lifter Do View.xlsx");
  };
  const [doData, setdoData] = useState();
  const findDoData = (id) => {
    setdoData(assignDetails.find((o) => o.assign_id === id));
  };
  const formateDate = (date) => {
    const [year, month, day] = date.split("-");
    const formattedDate = `${day}-${month}-${year}`;
    return formattedDate;
  };
  const handleValuesChange = (changedValues, allValues) => {
    const filteredData = assignList.filter(
      (item) =>
        item.lifter_name
          .toLowerCase()
          .includes((allValues.lifter_name || "").toLowerCase()) &&
        item.do_no.toLowerCase().includes((allValues.do_no || "").toLowerCase())
    );

    setassignDetails(filteredData);
  };

  return (
    <div style={{ height: "90vh" }}>
      <Header heading="LIFTER DO VIEW" />
      <Form form={form} layout="vertical" onValuesChange={handleValuesChange}>
        <div
          className=" grid grid-cols-1 sm:grid sm:grid-cols-3 sm:gap-2 m-auto px-5 sm:w-[70%]  md:w-[100%]"
          style={{ marginBottom: "10px" }}
        >
          <Col>
            <label>
              <b>Search By Do No.</b>
            </label>
            <br />
            <Form.Item name="do_no">
              <Input placeholder="Search by DO No." />
            </Form.Item>
          </Col>
          <Col>
            <label>
              <b>Search By Lifter Name</b>
            </label>
            <br />
            <Form.Item name="lifter_name">
              <Input placeholder="Search by Lifter Name." />
            </Form.Item>
          </Col>
          <Col>
            {localStorage.getItem("user_type") != "Lifter" && (
              <LifterAssFrm
                setassignDetails={setassignDetails}
                setassignList={setassignList}
              />
            )}
            <Button
              style={{
                bottom: "-5px",
                margin: "10px",
                backgroundColor: "black",
                color: "white",
                fontWeight: "600",
              }}
              onClick={handlePrint}
            >
              <FaFilePdf />
            </Button>
            <Button
              style={{
                bottom: "-5px",
                margin: "10px",
                backgroundColor: "green",
                color: "white",
                fontWeight: "600",
              }}
              onClick={handleExportToExcel}
            >
              <FaFileExcel />
            </Button>
          </Col>
        </div>
      </Form>
      <div className="table-wrapper" ref={componentRef}>
        <table id="my-table" className="w-full">
          {/* <div className="table-container" ref={componentRef}>
        <table id="my-table" className="w-full relative"> */}
          <thead className="bg-[#151B54] w-full text-white">
            <tr>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                Sr. No
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                Id
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                Lifter Name
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                Lifting Date
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                Party Name
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                Do No
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                Qty
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                Freight Rate
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                Shortage Rate
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                Rate Lifting
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                Dispatch Qty
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                Balance Qty
              </th>
         
                <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                  Action
                </th>
             
            </tr>
          </thead>
          <tbody>
            {assignDetails.map((e, index) => (
              <tr
                key={e.index}
                style={{ backgroundColor: e.rem_qty === 0 ? "#b8ebb8" : "" }}
              >
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {index + 1}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {e.assign_id}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {e.lifter_name}
                </td>

                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {formateDate(e.date)}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {e.client_name}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  <Link to={`/do-view/${e.do_id}`}>
                    <u style={{ fontWeight: "600", color: "blue" }}>
                      {e.do_no}
                    </u>
                  </Link>
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {e.quantity}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {e.freight_rate}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {e.shortage_rate}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {e.lifting_rate}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {e.dis_qty.toFixed(3)}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {e.rem_qty.toFixed(3)}
                </td>
                <td>
                  <EditOutlined
                    style={{ color: "blue", cursor: "pointer" }}
                    onClick={() => handleEdit(e)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <LifterAssignUpdate
        doData={selectedDo}
        setassignDetails={setassignDetails}
        setassignList={setassignList}
        isModalOpen={Boolean(selectedDo)}
        onClose={() => setSelectedDo(null)}
      />
      {/* <Footer /> */}
    </div>
  );
}
